import { QTY_SCALE } from './quantity-scale.js';
/** Collapses float drift so `0.1 + 0.2` compares equal to the 0.3 a Decimal(28,9) column holds. */
export function roundQuantity(value) {
    return Math.round(value * QTY_SCALE) / QTY_SCALE;
}
//# sourceMappingURL=round-quantity.js.map